'use strict'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import './PromoCard.scss'

class PromoCard extends PureComponent {
  render () {
    const { promos } = this.props
    const ccn = 'promo-card'

    if (!promos) return null

    return (
      <div className={ccn + ' xs-row xs-row--negative'}>
        {
          promos.map((promo, index) => {
            return (
              <a className={ccn + '__link ' + ccn + '__color--' + promo.colour + ' xs-12 sm-6 md-4'} href={promo.link} key={index}>
                <img className={ccn + '__img'} alt={promo.img_alt} src={promo.img_file} />
                <span className={ccn + '__content'}>
                  <h4 className={ccn + '__title'} dangerouslySetInnerHTML={{ __html: promo.title }} />
                  <p className={ccn + '__text'} dangerouslySetInnerHTML={{ __html: promo.message }} />
                </span>
                <span className={ccn + '__cta'}>{promo.cta}</span>
              </a>
            )
          })
        }
      </div>
    )
  }
}

PromoCard.propTypes = {
  promos: PropTypes.array
}

export default PromoCard
